import React from 'react'
import { translations } from '../data/translations'

const Header = ({
  language,
  setLanguage,
  isAdmin,
  onAdminLogin,
  onAdminLogout,
  showAdminControls,
}) => {
  const t = translations[language]

  return (
    <header className="header">
      <h1 className="title">{t.title}</h1>
      <h2 className="subtitle">{t.subtitle}</h2>

      <div className="language-switcher">
        <button
          className={language === 'RU' ? 'active' : ''}
          onClick={() => setLanguage('RU')}
          type="button"
        >
          RU
        </button>
        <button
          className={language === 'EN' ? 'active' : ''}
          onClick={() => setLanguage('EN')}
          type="button"
        >
          EN
        </button>

        {showAdminControls && (
          !isAdmin ? (
            <button
              type="button"
              className="admin-entry-btn"
              onClick={onAdminLogin}
            >
              Admin
            </button>
          ) : (
            <button
              type="button"
              className="admin-entry-btn active"
              onClick={onAdminLogout}
            >
              Admin Logout
            </button>
          )
        )}
      </div>

      <div className="forum-link-wrapper">
        <a
          href="https://t.me/marvelsnapcom"
          className="forum-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t.forumLink}
        </a>
      </div>
    </header>
  )
}

export default Header
